import React, { useState } from 'react';
import cn from 'classnames';
import Button from 'shared/buttons';

const OrderButton = ({
  title, className, icon, onClick, disabled, ...props
}) => {
  const btnClassName = cn('action-button', { [className]: className });
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);
    onClick().finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <Button
      id='action-button'
      responsive
      className={btnClassName}
      tooltip={title}
      icon={isLoading ? 'loading' : icon}
      onClick={handleClick}
      disabled={disabled || isLoading}
      {...props}
    />
  );
};

const ChangeOrderCell = ({
  order, numberOfItems, changeOrderRequest,
}) => {
  const onMoveToTop = () => changeOrderRequest({ value: 1 });
  const onMoveToBottom = () => changeOrderRequest({ value: numberOfItems });
  const onMoveUp = () => changeOrderRequest({ value: order - 1 });
  const onMoveDown = () => changeOrderRequest({ value: order + 1 });

  return (
    <td className='k-command-cell'>
      <OrderButton title='Move To Top' disabled={order === 1} onClick={onMoveToTop} icon='arrow-end-up' />
      <OrderButton title='Move Up' disabled={order === 1} onClick={onMoveUp} icon='arrow-60-up' />
      <OrderButton
        title='Move Down'
        disabled={order === numberOfItems}
        onClick={onMoveDown}
        icon='arrow-60-down'
      />  
      <OrderButton
        title='Move To Bottom'
        disabled={order === numberOfItems}
        onClick={onMoveToBottom}
        icon='arrow-end-down'
      />
    </td>
  );
};

export default ChangeOrderCell;
